import { MatchCard } from "@/components/competition/MatchCard";
import { Player, pct } from "@/components/competition/shared";

const BRACKETS = [["W", "Winners bracket"], ["L", "Losers bracket"], ["GF", "Grand final"], ["GF2", "Grand final reset"]];

const byRound = (ms) => Object.entries(ms.reduce((acc, m) => ({ ...acc, [m.round]: [...(acc[m.round] || []), m] }), {})).sort((a, b) => a[0] - b[0]);

export function Pairings({ matches, users, elimination, canManage, refresh }) {
  if (!matches.length) return <p className="text-sm text-slate-500" data-testid="pairings-empty">Pairings appear once the organizer starts the event.</p>;
  if (elimination) return (
    <div className="space-y-8" data-testid="bracket-view">
      {BRACKETS.map(([b, title]) => {
        const ms = matches.filter((m) => m.bracket === b);
        if (!ms.length) return null;
        return (
          <section key={b} data-testid={`bracket-${b}`}>
            <p className="eyebrow mb-3">{title}</p>
            <div className="flex gap-4 overflow-x-auto pb-2">
              {byRound(ms).map(([r, list]) => (
                <div key={r} className="flex w-60 shrink-0 flex-col justify-around gap-3">
                  {b !== "GF" && b !== "GF2" && <p className="font-mono text-[10px] uppercase text-slate-500">Round {r}</p>}
                  {list.map((m) => <MatchCard key={m.match_id} m={m} users={users} canManage={canManage} refresh={refresh} compact />)}
                </div>
              ))}
            </div>
          </section>
        );
      })}
    </div>
  );
  return (
    <div className="space-y-6" data-testid="rounds-view">
      {byRound(matches).reverse().map(([r, list]) => (
        <section key={r} data-testid={`round-${r}`}>
          <p className="eyebrow mb-3">{+r === 0 ? "Logged matches" : `Round ${r}`}</p>
          <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">{list.map((m) => <MatchCard key={m.match_id} m={m} users={users} canManage={canManage} refresh={refresh} />)}</div>
        </section>
      ))}
    </div>
  );
}

export function StandingsTable({ rows, users, elimination, testid = "standings-table" }) {
  if (!rows?.length) return <p className="text-sm text-slate-500" data-testid={`${testid}-empty`}>No standings yet.</p>;
  return (
    <div className="panel overflow-x-auto">
      <table className="w-full text-sm" data-testid={testid}>
        <thead className="font-mono text-[10px] uppercase tracking-wider text-slate-500">
          <tr className="text-left">{["#", "Player", ...(elimination ? ["Finish", "W–L"] : ["Pts", "W–L–D", "OMW%", "GW%", "OGW%"])].map((h) => <th key={h} className="whitespace-nowrap px-3 py-2">{h}</th>)}</tr>
        </thead>
        <tbody>{rows.map((r) => (
          <tr key={r.user_id} className="whitespace-nowrap border-t border-[#2A3447]" data-testid={`standing-row-${r.rank}`}>
            <td className={`px-3 py-2 font-display ${r.rank === 1 ? "text-amber-300" : "text-slate-400"}`}>{r.rank}</td>
            <td className="px-3 py-2"><Player user={users[r.user_id]} /></td>
            {elimination ? <><td className="px-3 py-2 text-slate-300">{r.eliminated_in}</td><td className="px-3 py-2 font-mono">{r.wins}–{r.losses}</td></>
              : <><td className="px-3 py-2 font-heading text-amber-100">{r.points}</td><td className="px-3 py-2 font-mono">{r.wins}–{r.losses}–{r.draws}</td>
                <td className="px-3 py-2 font-mono text-slate-400">{pct(r.omw)}</td><td className="px-3 py-2 font-mono text-slate-400">{pct(r.gwp)}</td><td className="px-3 py-2 font-mono text-slate-400">{pct(r.ogw)}</td></>}
          </tr>))}</tbody>
      </table>
    </div>
  );
}
